// Espace Interne Inyange — routing principal
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/CalendarPage";
import Boards from "@/pages/Boards";
import BoardView from "@/pages/BoardView";
import Tasks from "@/pages/Tasks";
import Announcements from "@/pages/Announcements";
import Messages from "@/pages/Messages";
import MediaRequests from "@/pages/MediaRequests";
import Resources from "@/pages/Resources";
import Agenda from "@/pages/Agenda";
import Team from "@/pages/Team";
import PublicAgenda from "@/pages/PublicAgenda";
import Admin from "@/pages/Admin";

const EcranChargement = () => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-background">
    <h1 className="font-serif text-3xl font-bold">Inyange</h1>
    <div className="h-1 w-24 overflow-hidden rounded-full bg-muted">
      <div className="h-full w-1/2 bg-primary animate-pulse rounded-full" />
    </div>
  </div>
);

// Route protégée : vérification serveur via /auth/me (source de vérité)
const ProtectedLayout = () => {
  const { user, loading } = useAuth();
  if (loading) return <EcranChargement />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout />;
};

function AppRouter() {
  const location = useLocation();
  // Détection synchrone du session_id OAuth (avant tout rendu de route)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/public/agenda/:token" element={<PublicAgenda />} />
      <Route element={<ProtectedLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calendrier" element={<CalendarPage />} />
        <Route path="/projets" element={<Boards />} />
        <Route path="/projets/:boardId" element={<BoardView />} />
        <Route path="/taches" element={<Tasks />} />
        <Route path="/annonces" element={<Announcements />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/demande-media" element={<MediaRequests />} />
        <Route path="/ressources" element={<Resources />} />
        <Route path="/agenda" element={<Agenda />} />
        <Route path="/equipe" element={<Team />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
